<ng-container
  *ngIf="
    dialogData.excluded.length !== 0 || dialogData.extraCharge.length !== 0;
    else emptyState
  "
>
  <div class="mb-dialog mb-dialog-custom">
    <mb-dialog-header>
      <h3
        class="mb-dialog-custom__header text"
        i18n="@@modals_charges_cargos_a_pagar_en_el_alojamiento_e_informacion_importante"
      >
        Cargos a pagar en el alojamiento e información importante
      </h3>
    </mb-dialog-header>
    <mb-dialog-body>
      <div class="mb-dialog-custom__body">
        <p *ngIf="dialogData.excluded.length !== 0">
          <span i18n="@@el_precio_de_esta_habitacion_no_incluye"
            >El precio de esta habitacion no incluye</span
          >&nbsp;<span *ngFor="let charge of dialogData.excluded; let last = last"
            >{{ charge.description }}&nbsp;<b *ngIf="charge.amount"
              >({{ dialogData.currencyCode }} {{ charge.amount | Currency }})</b
            ><span *ngIf="!last">,&nbsp;</span></span
          >
        </p>
        <p *ngIf="dialogData.extraCharge.length !== 0">
          <span *ngFor="let charge of dialogData.extraCharge; let last = last"
            >{{ charge.description }}<span *ngIf="charge.amount"
              >&nbsp;<span>Valor total:</span>&nbsp;<b
                >{{ dialogData.currencyCode }} {{ charge.amount | Currency }}</b
              ></span
            ><span *ngIf="!last">&nbsp;</span></span
          >
        </p>
      </div>
    </mb-dialog-body>
  </div>
</ng-container>
<ng-template #emptyState>
  <div class="mb-dialog mb-dialog-custom">
    <mb-dialog-header>
      <h3 class="mb-dialog-custom__header text">
        Cargos adicionales e información importante
      </h3>
    </mb-dialog-header>
    <mb-dialog-body>
      <div class="mb-dialog-custom__body">
        <div class="image">
          <img [src]="emptyStateImage" class="emptyStateImage" />
        </div>
        <p>
          <span class="subtitle-text">¡No hay novedades acerca de este alojamiento!</span
          ><br />
          <span class="body-text"
            >Cualquier información importante sobre el alojamiento o pago a realizar en el
            destino te lo estaremos informando.</span
          >
        </p>
      </div>
    </mb-dialog-body>
  </div>
</ng-template>
